import * as React from 'react';
import {Select} from '@sail/ui';

export const Primary = () => (
  <Select name="demo-001" label="Choose a pet">
    <option value="">Choose an option</option>
    <option value="dogs">Dogs</option>
    <option value="cats">Cats</option>
  </Select>
);
